<script>
	import { TwitchIcon, VideoIcon } from 'svelte-feather-icons'
	import { createEventDispatcher } from 'svelte';
	var dispatch = createEventDispatcher();
	import { onMount } from 'svelte';
	import { io } from './store.js';
	
	onMount(() => {

	});
	
</script>

<div class='con-page'>
	<div class='con-footer'>
		<div style='display:grid;'>
			<a href='/'>Home</a>
			<a href='/howtoplay'>How To Play</a>
			<a href='/contact'>Contact</a>
			<a href='/support'>Support Us</a>
		</div>
		<div></div>
		<div>
	
		</div>
	</div>
</div>


<style type="text/less">
	.con-page{
		display:grid;
		width:100%;

		a{
			color:rgba(255, 255, 255, 0.801) !important;
			font-size:0.8em;
			margin:3px;
			white-space: nowrap;;
		}
	}
	.con-footer{
		display:grid;
		grid-template-columns: min-content auto min-content;;

		justify-self:center;

		width: 100%;
		max-width:var(--mwidth);
		padding: 0 50px;
	}
</style>

